import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { InboxOutlined } from '@ant-design/icons';

interface EmptyMessageProps {
  height?: number;
}

const EmptyMessage = ({ height = 300 }: EmptyMessageProps) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: height ? `${height}px` : '100%',
          gap: 8,
        }}
      >
        <InboxOutlined
          style={{
            fontSize: 48,
            opacity: 0.3,
          }}
        />
        <SectionType2DescIconText>
          {t('currentlyNoData')}
        </SectionType2DescIconText>
      </div>
    </div>
  );
};

export default EmptyMessage;

const SectionType2DescIconText = styled.div`
  color: ${({ theme }) => theme.COLORS.sectionDesc};
  text-align: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
